import { Component, OnInit } from '@angular/core';
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";

import { CommonmastersService } from "../../commonmasters/commonmasters.service";
import { SavingstransactionService } from "../shared/savingstransaction.service";

import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../utility/shared/toastpayload";
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-savingsaccrued',
  templateUrl: './savingsaccrued.component.html',
  styleUrls: ['./savingsaccrued.component.css']
})

export class SavingsaccruedComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  CustomerName: string;
  SavingsBalance: string;
  SavingAccuredNo: number;
  PaymentTypeList: any[] = [];
  BankList: any[] = [];
  DepositsList: any[] = [];

  SavingTransactionId: number;
  Address: string;
  IsSavingsNoExist: boolean;
  toast: Toastpayload;

  constructor(
    public savingstransactionService: SavingstransactionService,
    private commonmastersService: CommonmastersService,
    private router: Router, private route: ActivatedRoute,
    private toasterserviceService: ToasterserviceService,
    private ngxLoader: NgxUiLoaderService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.SavingTransactionId = +  params['Id'];
    });

    this.resetForm();

    // showing Loader 
    this.ngxLoader.start(); // Adding beacuse you will try to search before loading the saving No
    this.FetchDepositNoList(); // Using to populate Savings No, while loading the page. due to savings no. based on branchId.

    if (Number.isNaN(this.SavingTransactionId)) {
      this.savingstransactionService.selectedSavingsTransaction.Id = 0;
      this.savingstransactionService.selectedSavingsTransaction.Flag = 1;
      this.savingstransactionService.selectedSavingsTransaction.IsActive = true;
      this.AddButtonText = "Save";
      this.GetAutogeneratedNumber();
    }
    // else {
    //   this.savingstransactionService.selectedSavingsTransaction.Id = +this.SavingTransactionId;
    //   this.savingstransactionService.selectedSavingsTransaction.Flag = 2;
    //   // this.savingstransactionService.selectedSavingsTransaction.IsActive = 1;
    //   this.AddButtonText = "Edit";
    //   this.GetSavingTransactionByNo();
    // }

  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.savingstransactionService.selectedSavingsTransaction = {

      Id: 0,
      TransactionNo: 0,
      SavingsId: null,
      TransactionDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
      CollectionAmount: 0.0,
      PrincipleAmount: null,
      InterestAmount: null,
      BalanceAmount: 0,
      LateFeeAmount: 0,
      InstallmentNo: 0,
      IsPartPayment: false,
      IsPreclosure: false,
      PaymentTypeId: 0,
      PaymentBankId: 0,
      ChequeNo: null,
      Remarks: "Savings accrued payments",
      IsAccruedAmount: true,
      IsSavingsclosed: null,
      IsReceiptAmount: false,

      ReportName: null,

      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      CreatedDate: null,
      ModifiedDate: null,
      IsActive: null,
      Flag: null,
      IsOpening: false,
    }
  }

  onSubmit(form: NgForm) {
    if (this.savingstransactionService.selectedSavingsTransaction.SavingsId != 0) {
      this.savingstransactionService.IUDSavingstransaction(form.value)
        .subscribe(data => {
          // this.resetForm(form);
          this.router.navigate(['/savingsaccruedlist']);
        })
    }
  }

  GetAutogeneratedNumber(): any {

    if (this.savingstransactionService.selectedSavingsTransaction.TransactionNo == 0) {
      const myAutoGeneratedId = this.commonmastersService.FetchAutogeneratedNumber()
        .toPromise()
        .then(res => {
          this.savingstransactionService.selectedSavingsTransaction.TransactionNo = res[0].AutoGeneratedId;
          return Promise.resolve(res[0].AutoGeneratedId);
        })
        .catch(err => { console.log(err) });
    }
  }

  GetSavingTransactionByNo() {

    if (this.savingstransactionService.selectedSavingsTransaction.Id !== 0) {
      this.savingstransactionService.FetchSavingsTransactionByNo(this.savingstransactionService.selectedSavingsTransaction)
        .subscribe(data => {
          this.savingstransactionService.selectedSavingsTransaction = data;
          this.savingstransactionService.selectedSavingsTransaction.Flag = 2;
        })
    }
  }

  public changeDepositNo(SavingsId: any) {

    this.IsSavingsNoExist = false;
    for (var i = 0; i < this.DepositsList.length; i++) {

      if (this.DepositsList[i]["Id"] == SavingsId) {
        // this.CustomerName = this.DepositsList[i]["CustomerName"];
        // this.Address = this.DepositsList[i]["Address"];
        // this.DepositType = this.DepositsList[i]["SchemeName"];
        // this.SavingsBalance = this.DepositsList[i]["SavingsBalance"];

        this.CustomerName = this.DepositsList[i]["CustomerName"];
        this.SavingsBalance = this.DepositsList[i]["SavingsBalance"];
        this.Address = this.DepositsList[i]["CustomerAddress"];
        this.IsSavingsNoExist = true;
      }
    }
    
    this.toast = {
      message: "No Message Now!",
      title: 'Savings Accrued',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    if(this.IsSavingsNoExist){

      this.toast.message = 'Please enter the interest amount.'
      this.toast.type = 'success';
      this.toasterserviceService.showToast(this.toast);
    }
    else{
      this.toast.message = 'The given Savings No. does not exist!'
      this.toast.type = 'error';
      this.toasterserviceService.showToast(this.toast);
      this.GetAutogeneratedNumber(); // refresing the transaction no.
    }
  }

  FetchDepositNoList() {
    
    this.savingstransactionService.FetchDepositNoList()
      .subscribe(data => {
        this.DepositsList = data;
        // Closing Loader for deposit nos while page loading.
        this.ngxLoader.stop();
      })
  }

  SavingsNoSearch(SavingsNo: number) {

    // showing Loader 
    this.ngxLoader.start();
    // clear the existing details
    this.CustomerName = "";
    this.SavingsBalance = "";
    this.Address = "";

    this.changeDepositNo(this.savingstransactionService.selectedSavingsTransaction.SavingsId)
    event.preventDefault();  // restricting event bubbling.
    // Closing Loader
    this.ngxLoader.stop();
  }

}

